import React, { RefObject } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { ScheduleI } from '~src/interfaces/schedule.interface';
import { SessionUserI } from '~src/interfaces/session.types';
import { fetchSchedule } from '~src/modules/surveys/components/schedules/actions/backendActions';
import { getDefaultSchedule } from '~src/modules/surveys/constants/defaultSchedule';
import { Survey } from '~src/modules/surveys/interfaces';
import { StoreI } from '~src/rootReducer';
import StatusBox from '~src/shared/StatusBox';
import LoadingSpinner from '~src/shared/loadingSpinner/LoadingSpinner';

import {
  LoadingContainer,
  SchedulesHeaderText,
  SchedulesItemContainer,
  SchedulesItemHeader,
  TemplateContainer,
} from './schedulesItem.sc';
import ScheduleTemplate from './templates/ScheduleTemplate';

interface OwnProps {
  survey: Survey;
  schedule: ScheduleI | null;
  addItem?: boolean;
  fixedAddForm?: boolean;
}

interface StateProps {
  sessionUser: SessionUserI;
}

interface State {
  currentSchedule: ScheduleI;
  loadingSchedule: boolean;
}

interface DefaultProps {
  addItem: boolean;
  fixedAddForm: boolean;
}

type Props = OwnProps & StateProps & WithTranslation;

class SchedulesItem extends React.Component<Props, State> {
  static defaultProps: DefaultProps = {
    addItem: false,
    fixedAddForm: false,
  };

  topElRef: RefObject<HTMLDivElement>;

  isUnmounted: boolean;
  constructor(props: Props) {
    super(props);
    this.state = {
      currentSchedule: getDefaultSchedule(props.sessionUser, props.survey.id),
      loadingSchedule: true,
    };
    this.isUnmounted = false;
    this.topElRef = React.createRef();
  }

  componentWillUnmount = () => {
    this.isUnmounted = true;
  };

  componentDidMount = () => {
    if (this.props.schedule && this.props.schedule.id) {
      void fetchSchedule(this.props.schedule.id)
        .then((schedule) => {
          this.setState({ currentSchedule: schedule });
        })
        .finally(() => {
          if (!this.isUnmounted) {
            this.setState({ loadingSchedule: false });
          }
        });
    } else {
      if (!this.isUnmounted) {
        this.setState({ loadingSchedule: false });
      }
    }

    const topEl = this.topElRef.current;
    const scrollingEl = document.children[0];

    if (topEl && scrollingEl) {
      setTimeout(() => {
        scrollingEl.scrollTo({ top: topEl.offsetTop - 20, behavior: 'smooth' });
      }, 40);
    }
  };

  renderTemplate = () => {
    if (this.state.loadingSchedule) {
      return (
        <LoadingContainer>
          <LoadingSpinner />
        </LoadingContainer>
      );
    }
    return (
      <ScheduleTemplate
        t={this.props.t}
        fixedAddForm={this.props.fixedAddForm}
        isAddSchedule={!this.props.schedule}
        schedule={this.state.currentSchedule}
        survey={this.props.survey}
      />
    );
  };

  render() {
    const { t } = this.props;
    return (
      <SchedulesItemContainer $displayed $show ref={this.topElRef}>
        <SchedulesItemHeader>
          <SchedulesHeaderText>
            <span data-translation={`x.surveys.schedules.header.single.${this.props.survey.scope}`}>
              {t(`x.surveys.schedules.header.single.${this.props.survey.scope}`)}
            </span>
          </SchedulesHeaderText>
          {/* Check for aktivity of the Schedule */}
          {this.props.schedule && (
            <StatusBox style={{ marginRight: 30 }} active={this.props.schedule.active} />
          )}
        </SchedulesItemHeader>
        <TemplateContainer $show>{this.renderTemplate()}</TemplateContainer>
      </SchedulesItemContainer>
    );
  }
}

function mapStateToProps(state: StoreI): StateProps {
  return {
    sessionUser: state.user.session.user!,
  };
}

const SchedulesItemTranslated = withTranslation()(SchedulesItem);
const SchedulesItemSuperComponent = connect(mapStateToProps)(SchedulesItemTranslated);
export default SchedulesItemSuperComponent;
